import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

var SECTIONS = [
  { key: 'inspectionData', titleKey: 'inspect:sectionInspectionData', required: true },
  { key: 'assetType', titleKey: 'inspect:sectionAssetType', required: false },
  { key: 'passFailCriteria', titleKey: 'inspect:sectionPassFail', required: true },
  { key: 'recurrence', titleKey: 'inspect:sectionRecurrence', required: false },
  { key: 'activeInactive', titleKey: 'inspect:sectionActiveInactive', required: false },
  { key: 'neglectWarnings', titleKey: 'inspect:sectionNeglectWarnings', required: false },
  { key: 'columns', titleKey: 'inspect:sectionColumns', required: false, unnumbered: true },
  { key: 'notifications', titleKey: 'inspect:sectionNotifications', required: false, comingSoon: true },
];

var InspectSettingsNav = function (props) {
  var activeSection = props.activeSection;
  var onSectionClick = props.onSectionClick;
  var isNewMode = props.isNewMode;
  var sectionStatus = props.sectionStatus;
  var sectionErrors = props.sectionErrors || {};
  var t = useTranslation().t;

  var stepNumber = 0;

  return (
    <div className="inspect-settings-nav">
      {SECTIONS.map(function (section) {
        if (!section.unnumbered) stepNumber += 1;
        var isActive = activeSection === section.key;
        var isComingSoon = !!section.comingSoon;
        var status = sectionStatus[section.key];
        var isComplete = status && status.complete;
        var subtitle = '';

        if (section.unnumbered && status && status.summary) {
          subtitle = status.summary;
        } else if (isComingSoon) {
          subtitle = t('inspect:sectionComingSoonSubtitle');
        } else if (isNewMode) {
          if (isComplete && status.summary) {
            subtitle = status.summary;
          } else if (isActive) {
            subtitle = t('inspect:sectionInProgress');
          } else if (!section.required) {
            subtitle = t('inspect:sectionOptional');
          } else {
            subtitle = t('inspect:sectionNotSet');
          }
        } else {
          if (status && status.summary) {
            subtitle = status.summary;
          } else if (!section.required) {
            subtitle = t('inspect:sectionNotConfigured');
          } else {
            subtitle = t('inspect:sectionNotSet');
          }
        }

        var hasError = !!sectionErrors[section.key];
        var indicatorClass = 'inspect-settings-nav-item-indicator';
        if (hasError) {
          indicatorClass += ' error';
        } else if (isNewMode && !section.unnumbered) {
          if (isComplete) {
            indicatorClass += ' complete';
          } else if (isActive) {
            indicatorClass += ' current';
          } else {
            indicatorClass += ' pending';
          }
        }

        var itemClass = 'inspect-settings-nav-item';
        if (isActive) itemClass += ' active';

        var handleClick = function () {
          onSectionClick(section.key);
        };

        return (
          <div
            key={section.key}
            className={itemClass}
            onClick={handleClick}
          >
            {((isNewMode && !section.unnumbered) || hasError) && (
              <div className={indicatorClass}>
                {hasError ? (
                  <span className="material-symbols-outlined" style={{ fontSize: 14 }}>priority_high</span>
                ) : isComplete ? (
                  <span className="material-symbols-outlined" style={{ fontSize: 14 }}>check</span>
                ) : (
                  stepNumber
                )}
              </div>
            )}
            <div className="inspect-settings-nav-item-text">
              <div className="inspect-settings-nav-item-title">
                <span>{t(section.titleKey)}</span>
                {isComingSoon && (
                  <span className="inspect-settings-nav-item-badge">
                    {t('inspect:sectionComingSoon')}
                  </span>
                )}
              </div>
              <div className="inspect-settings-nav-item-subtitle">
                {subtitle}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

InspectSettingsNav.propTypes = {
  activeSection: PropTypes.string.isRequired,
  onSectionClick: PropTypes.func.isRequired,
  isNewMode: PropTypes.bool.isRequired,
  sectionStatus: PropTypes.object.isRequired,
  sectionErrors: PropTypes.object,
};

export default InspectSettingsNav;
